(function($){
        
    $(document).on("click", ".btn-toggler", function(){
        $(this).parent().parent().find(".js-content-toggle").addClass('toggle-active'); 
        $(this).hide();
    });

})(jQuery);


// WEBPACK FOOTER //
// ../views/blocks/texte-image/assets/script.js